<template>
    <div  @click="$emit('cancel')" class="w-full h-[150%] fixed top-0 left-0 bg-[#00000063] z-40 backdrop-blur-[2px]">
    </div>
        <div class="flex flex-col justify-center fixed left-0 top-[30%] mx-[40%] z-40 bg-white w-[450px] text-lg rounded-lg border-[2px] border-[#0B6014]">
            <div class="pafcpic_header bg-[#006A00] py-3 px-6">

                <p class="text-[#ffffff] text-md font-bold">Message</p>
            </div>
            <div class="pafcpic_body py-3 px-6">
                <p class="text-xs text-[#818181] ml-1 font-medium mb-1">To</p>
                <select class="col-span-2 border-[#ACA9A9] border rounded-md py-3 px-2 text-sm text-[#12760A] font-semibold w-full mb-2" v-model="to">
                    <option value="" selected disabled>Select Employee</option>
                    <option v-for="(info,index) in GetName" :key="index" :value="info.employee_key">{{ info.full_name }}</option>
                </select>
                <p class="text-xs text-[#818181] ml-1 font-medium mb-1">Message</p>
                <textarea  class="border-[#ACA9A9] border rounded-md w-full py-3 px-3 text-sm outline-none text-[#12760A] font-semibold " placeholder="Enter your message" v-model="message"></textarea>
            </div>
        <div class="pafcpic_footer flex gap-4 justify-end px-5 py-3 border-[#00800048] border-t font-medium">
            <button class="text-sm text-white bg-[#006A00] py-1.5 px-7 rounded-md" @click="$emit('sendMessage',to,message)">Send Message</button>
            <button class="text-sm text-[#6A6A6A] bg-[#D9D9D9] py-1.5 px-7 rounded-md" @click="$emit('cancel')">Cancel</button>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import Services from "../../../services/admin"

export default defineComponent({

    data(){
        return{
            GetName:'',
            to:'',
        }
    },
    mounted(){
        this.getEmployeeName()
    },
    methods:{ 
        async getEmployeeName(){
            const success    =  await Services.getEmployeeName()
            this.GetName     =  success.data
        }
        
    }

})

</script>